import { faSearch } from "@fortawesome/free-solid-svg-icons"
import Icon from "../Icon"

export default ({ image, name, onCancel = () => {} }) => {
    return (
        <>
            <p className="recent-searches d-flex p-3 m-2">
                <Icon icon={faSearch} className={"text-saffron"} />
                <span className="font-16 text-light">{ name || "DEV Deepawali"}</span>
            </p>
        </>
    )
}